import { camelizeKeys } from "lib/helpers/convertObjKeys";
import { setOrgStaffTeamView } from "rdx/modules/enterpriseProjects/slice";
import actions from "../rdx/actions";
import { store } from "../rdx/configureStore";
import UserClass from "./User";

export default class SessionUser extends UserClass {
  constructor(session) {
    const props = session.data.user;
    const userProps = { ...props };
    if (!props.enrollment) {
      userProps.enrollment = {};
    }
    if (!props.address) {
      userProps.address = {};
    }
    super(userProps);
    this.session = session;
  }

  patch() {
    return super.patch().then(this.resToSession);
  }

  acceptTos() {
    return this.api.patch("/user/tos", {}).then(this.resToSession);
  }

  resToSession = (res) => {
    if (res.body.user) {
      store.dispatch(setOrgStaffTeamView(res.body.user.is_org_team_staff || false));
      this.session.user = res.body.user;
    }
    if (res.body.impersonator) this.session.impersonating = res.body.impersonator;
    if (res.body.banners) {
      this.session.banners = res.body.banners;
      store.dispatch(actions.setBanners(res.body.banners));
    }
    if (res.body.rbac) this.session.rbac = res.body;
    else this.session.user = res.body;
    return res;
  };

  reload(source, options) {
    return this.get(source, options).then(this.resToSession).then(this.initStore);
  }

  initStore = (data) => {
    const { user, rbac, notices, mentorRating, pastDueHomeownerAppointment, zendeskToken } = camelizeKeys(data.body);

    if (user) {
      store.dispatch(actions.setCurrentUser(user));
    }

    if (rbac && rbac.permissions) {
      const { permissions } = rbac;
      store.dispatch(actions.setUserPermissions({ permissions }));
    }

    if (notices) {
      store.dispatch(actions.updateUnviewedNotices(notices));
    }

    if (mentorRating) {
      store.dispatch(actions.setMentorRating(mentorRating));
    }

    if (pastDueHomeownerAppointment) {
      store.dispatch(actions.setUserPastDueHomeownerAppointment(pastDueHomeownerAppointment));
    }

    if (user) {
      store.dispatch(actions.setUserRequirePaymentData(Boolean(user.requirePaymentData)));
    }

    if (zendeskToken) {
      store.dispatch(actions.setZendeskToken(zendeskToken));
    }
  };

  clearStore = () => {
    store.dispatch(actions.clearRbac());
  };
}
